module.exports = __webpack_public_path__ + "static/media/Museo-Thyssen-Bornemisza.d059aee5.jpg";